import fetch from 'isomorphic-fetch'
import _log from './logger'
import _cookies from './cookies'

const TOKEN = _cookies.keys.TOKEN
const APIKEY = _cookies.keys.APIKEY

let httpClient = {
    "get": get,
    "getBlob": getBlob,
    "post": post,
    "postNoToken": postNoToken
}

/**
 * Looks for error statuses and throws error if they occur
 * @param {*} response 
 */
function checkStatus(response) {
    if (response.status >= 400) {
        var error = new Error(response.statusText);
        error.response = response;
        throw error;
    }
    return response;
}

export function get(url) {
    let options = {method: 'get', headers: getHeaders()}
    return fetch(url, options)
        .then(checkStatus)
        .then(response => {
            return response.json()
        })
}

export function getBlob(url) {
    var token = _cookies.read(TOKEN);
    var apikey = _cookies.read(APIKEY);
    let options = {
        method: 'get', 
        headers: {
            'Access-Control-Allow-Origin':'*',
            'Content-Type' : 'application/pdf',
            'Authorization' : 'Bearer ' + token,
            'api-key': apikey
        },
        responseType: 'blob'
    }

    return fetch(url, options)
        .then(checkStatus)
        .then(response => response.blob())
}

export function post(url, o) {
    return fetch(url, {method: 'post', body: o, headers: getHeaders()})
        .then(checkStatus)
        .then(response => {
            return response.json();
        })
}

export function postNoToken(url, o) {
    return fetch(url, {method: 'post', body: o, headers: getHeaders(false)})
        .then(checkStatus)
        .then(response => {
            return response.json();
        })
}

function getHeaders(includeToken = true) {
    _log.debug("httpClient.getHeaders");

    var apikey = _cookies.read(APIKEY);

    var result = {
        "Access-Control-Allow-Origin":"*",
        "Content-Type" : "application/json",
        "api-key": apikey
    };
    
    if (includeToken) {
        var token = _cookies.read(TOKEN);
        if (token) {
            result.Authorization = "Bearer " + token
        }
    }

    return result;
}

export default httpClient

    


// WEBPACK FOOTER //
// ./src/util/httpClient.js